<template>
  <div class="space-y-20">
    <div>
      <p v-if="orderline.shippingDate">
        {{
          i18n(translations.shippingDate, {
            shippingDate: new Date(orderline.shippingDate),
          })
        }}
      </p>
      <p
        v-if="
          orderline.delivery.minDeliveryDate !== null &&
          orderline.delivery.maxDeliveryDate !== null
        "
      >
        {{
          i18n(translations.estimatedDeliveryDate, {
            min: new Date(orderline.delivery.minDeliveryDate),
            max: new Date(orderline.delivery.maxDeliveryDate),
          })
        }}
      </p>
      <p v-if="orderline.delivery?.deliveryDate">
        {{
          i18n(translations.deliveryDate, {
            deliveryDate: new Date(orderline.delivery.deliveryDate),
          })
        }}
      </p>
    </div>

    <div>
      {{ i18n(labelOriginTranslation) }}

      <div v-if="!isEmpty(orderline.delivery?.carrierName)">
        {{
          i18n(translations.carrier, {
            backship: orderline.delivery.isBackship,
            carrier: orderline.delivery.carrierName,
          })
        }}
      </div>
      <div>
        {{
          i18n(translations.trackingNumber, {
            trackingNumber: orderline.delivery.trackingNumber,
          })
        }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import type { Orderline } from '~/api/care-folders/types/care-folder'

import translations from './ShippingList.translations'

const props = defineProps<{
  orderline: Orderline
}>()

const i18n = useI18n()

const labelOriginTranslation = computed(() => {
  /* The BackShip service is not available when we are launching some countries,
      In those countries we need to indicate the carrier's name */
  return props.orderline.delivery.isBackship
    ? translations.backshipLabel
    : translations.sellerLabel
})
</script>
